// HOOKS
import { createContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useValidateToken from "../hooks/users/useValidateToken";

const UNAUTHENTICATED_ROUTES = ["/login", "/reset-password"];

export const UserContext = createContext({
  user: null,
  setUser: () => {},
});

export const UserProvider = ({ children }) => {
  const token = localStorage.getItem("token");
  const { data, loading } = useValidateToken();
  const [user, setUser] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return; // If there's no token, don't do anything

    // Check if user is logged in and if loading is complete
    const existingUser = data?.verifyUser || null;

    // If user exists, update the user state
    if (existingUser) {
      setUser(existingUser);
    } else if (
      !loading &&
      !existingUser &&
      !UNAUTHENTICATED_ROUTES.includes(location.pathname) &&
      !location.pathname.includes("/reset-password/")
    ) {
      // If loading is done, no user is found, and the current path is not an unauthenticated route,
      // remove the token and redirect to login
      localStorage.removeItem("token");
      navigate("/login");
    }
  }, [data, loading, location.pathname, navigate]);

  useEffect(() => {
    // Handle user navigation post-login or logout
    if (
      (location.pathname === "/login" || location.pathname === "/") &&
      user?._id &&
      token
    ) {
      // If the user is on the login page, has a valid ID, and a token, navigate to a protected part of the app
      navigate("/parts/open");
    } else if (
      !user?._id &&
      !token &&
      !UNAUTHENTICATED_ROUTES.includes(location.pathname) &&
      !location.pathname.includes("/reset-password/")
    ) {
      // If there is no user ID or token, and the user is not on an UNAUTHENTICATED_ROUTES page, redirect to login
      navigate("/login");
    }
  }, [user, token, location.pathname, navigate]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
